var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.verified)?_c('span',{staticClass:"verified-badge",attrs:{"title":_vm.tip}},[_c('img',{attrs:{"src":_vm.verifiedIcon,"width":_vm.size,"height":_vm.size,"alt":"已认证"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }